function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { fetch } from '@micun/web-components';
import { useQuery } from '@tanstack/react-query';
import { useForm } from 'antd/es/form/Form';
import JSONBig from 'json-bigint';
import { clone, cloneDeep, isEqual } from 'lodash';
import { nanoid } from 'nanoid';
import qs from 'qs';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
var emptyArr = [];
Object.freeze(emptyArr);
var dealArr = function dealArr(arr) {
  arr = arr.filter(function (v) {
    return v !== null && v !== undefined && v !== '';
  }).map(function (v) {
    if (Array.isArray(v)) {
      return dealArr(v);
    }
    if (_typeof(v) === 'object') {
      return dataFilter(v);
    }
    if (typeof v === 'string') {
      return v.trim();
    }
    return v;
  });
  return arr;
};
export var dataFilter = function dataFilter(o) {
  if (!o) {
    return o;
  }
  Object.keys(o).forEach(function (k) {
    if (o[k] === null || o[k] === undefined || o[k] === '') {
      delete o[k];
    }
    if (typeof o[k] === 'string') {
      o[k] = o[k].trim();
    }
    if (Array.isArray(o[k])) {
      o[k] = dealArr(o[k]);
      if (o[k].length === 0) {
        delete o[k];
      }
    }
    if (_typeof(o[k]) === 'object' && k !== 'page') {
      return dataFilter(o[k]);
    }
  });
  return o;
};
export var SortOrderMap = {
  ascend: 'ASC',
  descend: 'DESC'
};
var DEFAULT_PAGE_SIZE = 10;
var sorterRecordToSorts = function sorterRecordToSorts(sorterRecord) {
  var sorts = [];
  Object.entries(sorterRecord || {}).forEach(function (pair) {
    var _pair = _slicedToArray(pair, 2),
      field = _pair[0],
      order = _pair[1];
    if (order) {
      sorts.push({
        field: field,
        direction: SortOrderMap[order]
      });
    }
  });
  return sorts.length > 0 ? sorts : undefined;
};
var createRequestQuery = function createRequestQuery(pageSize, initSort) {
  return {
    page: {
      index: 1,
      size: pageSize,
      sorts: sorterRecordToSorts(initSort)
    }
  };
};
var showTotal = function showTotal(total, range) {
  return "\u7B2C ".concat(range[0], "-").concat(range[1], " \u6761 / \u5171 ").concat(total, " \u6761");
};
var createTableQuery = function createTableQuery(pageSize, initSort) {
  return {
    pagination: {
      current: 1,
      pageSize: pageSize
    },
    sorter: initSort || {},
    filters: {}
  };
};
export function useTableQuery(options) {
  var url = options.url,
    shouldRequest = options.shouldRequest,
    replaceUrlState = options.replaceUrlState,
    _options$initialQuery = options.initialQuery,
    initialQuery = _options$initialQuery === void 0 ? {} : _options$initialQuery,
    _options$pageSize = options.pageSize,
    pageSize = _options$pageSize === void 0 ? DEFAULT_PAGE_SIZE : _options$pageSize,
    initialSort = options.initialSort,
    requestFilter = options.requestFilter,
    responseFilter = options.responseFilter,
    outerSearchConnect = options.searchConnect,
    searchConnectFilter = options.searchConnectFilter,
    _options$useBigInt = options.useBigInt,
    useBigInt = _options$useBigInt === void 0 ? false : _options$useBigInt;
  var method = (options.method || 'GET').toUpperCase();
  var _useForm = useForm(),
    _useForm2 = _slicedToArray(_useForm, 1),
    searchForm = _useForm2[0];
  var innerSearchConnect = useRef({
    form: searchForm
  });
  var searchConnect = outerSearchConnect || innerSearchConnect;
  var defaultReqQuery = createRequestQuery(pageSize, initialSort);
  var defaultTableQuery = createTableQuery(pageSize, initialSort);
  var queryTimesRef = useRef(0);
  var _useState = useState(function () {
      var searchLink = window.location.search;
      if (searchLink.length > 1) {
        searchLink = searchLink.substring(1);
        var o = qs.parse(searchLink);
        return _objectSpread(_objectSpread({}, initialQuery), o);
      }
      return _objectSpread({}, initialQuery);
    }),
    _useState2 = _slicedToArray(_useState, 1),
    searchObj = _useState2[0];
  var _useState3 = useState(function () {
      var page = searchObj.page;
      if (replaceUrlState) {
        return _objectSpread(_objectSpread({}, searchObj), page || cloneDeep(defaultReqQuery));
      }
      return _objectSpread(_objectSpread({}, initialQuery), cloneDeep(defaultReqQuery));
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    requestQuery = _useState4[0],
    setRequestQuery = _useState4[1];
  var _useState5 = useState(function () {
      if (searchConnect) {
        var page = searchObj.page;
        if (replaceUrlState && page) {
          return _objectSpread(_objectSpread({}, searchObj), {}, {
            pagination: {
              current: page.index,
              pageSize: page.size
            },
            sorter: page.sort || {},
            filters: page.filter || {}
          });
        }
        return _objectSpread(_objectSpread({}, searchObj), cloneDeep(defaultTableQuery));
      }
      return _objectSpread(_objectSpread({}, initialQuery), cloneDeep(defaultTableQuery));
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    tableQuery = _useState6[0],
    setTableQuery = _useState6[1];
  useEffect(function () {
    var _searchConnect$curren;
    var formInstance = (_searchConnect$curren = searchConnect.current) === null || _searchConnect$curren === void 0 ? void 0 : _searchConnect$curren.form;
    if (formInstance) {
      formInstance === null || formInstance === void 0 || formInstance.setFieldsValue(searchConnectFilter ? searchConnectFilter(searchObj) : searchObj);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var _useQuery = useQuery({
      queryKey: ['table-list', url, requestQuery, requestFilter],
      retry: false,
      refetchOnWindowFocus: false,
      queryFn: function queryFn() {
        queryTimesRef.current++;
        if (shouldRequest && !shouldRequest({
          queryTimes: queryTimesRef.current,
          requestQuery: requestQuery
        })) {
          return [];
        }
        var nextQuery = requestQuery;
        if (requestFilter) {
          nextQuery = requestFilter(clone(requestQuery));
        }
        var extras = useBigInt ? {
          transformRequest: [function (data) {
            // 使用 json-bigint 序列化请求数据
            if (data) {
              return JSONBig.stringify(data);
            }
            return data;
          }],
          transformResponse: [function (data) {
            // 使用 json-bigint 解析响应数据
            if (data) {
              try {
                return JSONBig.parse(data);
              } catch (error) {
                console.error('Error parsing JSON with BigInt:', error);
              }
            }
            return data;
          }]
        } : {};
        var req = fetch(_objectSpread(_objectSpread({}, extras), {}, _defineProperty({
          url: url,
          method: method
        }, method === 'GET' ? 'query' : 'data', dataFilter(nextQuery))));
        return req.then(function (data) {
          var resData = data.data;
          if (responseFilter) {
            resData = responseFilter(resData);
          }
          var _resData = resData,
            _resData$data = _resData.data,
            list = _resData$data === void 0 ? emptyArr : _resData$data,
            page = _resData.page,
            totalCount = _resData.totalCount;
          handleListUpdate(page, totalCount);
          var nextList = list === null || list === void 0 ? void 0 : list.map(function (item) {
            var _item$children;
            return _objectSpread(_objectSpread({
              key: (item === null || item === void 0 ? void 0 : item['key']) || nanoid()
            }, item), {}, {
              children: item === null || item === void 0 || (_item$children = item['children']) === null || _item$children === void 0 ? void 0 : _item$children.map(function (i) {
                return _objectSpread({
                  key: (i === null || i === void 0 ? void 0 : i['key']) || nanoid()
                }, i);
              })
            });
          });
          return nextList;
        });
      }
    }),
    isFetching = _useQuery.isFetching,
    _useQuery$data = _useQuery.data,
    data = _useQuery$data === void 0 ? emptyArr : _useQuery$data,
    refetch = _useQuery.refetch;
  var modifyTableQuery = useCallback(function (tableQuery) {
    var normalizePage = function normalizePage(page) {
      var _page$sorts;
      return {
        index: Number(page.index),
        size: Number(page.size),
        sorts: ((_page$sorts = page.sorts) === null || _page$sorts === void 0 ? void 0 : _page$sorts.map(function (sort) {
          return _objectSpread({}, sort);
        })) || []
      };
    };
    var isPageEqual = function isPageEqual(pageA, pageB) {
      var normalizedA = normalizePage(pageA);
      var normalizedB = normalizePage(pageB);
      return isEqual(normalizedA, normalizedB);
    };
    var pagination = tableQuery.pagination,
      sorter = tableQuery.sorter;
    var sorts = sorterRecordToSorts(sorter);
    // page map
    var current = pagination.current,
      pageSize = pagination.pageSize;
    var page = {
      index: String(Math.max(1, current || 1)),
      size: String(pageSize),
      sorts: sorts
    };
    if (!isPageEqual(page, requestQuery.page)) {
      setRequestQuery(function (state) {
        var newState = _objectSpread(_objectSpread({}, state), {}, {
          page: page
        });
        if (replaceUrlState) {
          var search = qs.stringify(newState);
          window.history.replaceState({}, '', search ? "?".concat(search) : '');
        }
        return newState;
      });
    }
    setTableQuery(tableQuery);
  }, [replaceUrlState, requestQuery.page]);
  var handleTableChange = useCallback(function (pagination, filters, sorter) {
    var _sorter$column;
    var nextSorter = {};
    if (!sorter.field && (_sorter$column = sorter.column) !== null && _sorter$column !== void 0 && _sorter$column.dataIndex) {
      var field = sorter.column.dataIndex;
      var fieldKey = Array.isArray(field) ? field.join('.') : field;
      nextSorter["".concat(fieldKey)] = sorter.order;
    } else if (sorter.field) {
      var _field = sorter.field;
      var _fieldKey = Array.isArray(_field) ? _field.join('.') : _field;
      nextSorter[_fieldKey] = sorter.order;
    }
    var nextTableQuery = {
      pagination: _objectSpread(_objectSpread({}, tableQuery.pagination), pagination),
      sorter: nextSorter,
      filters: filters
    };
    var changed = !isEqual(tableQuery, nextTableQuery);
    if (changed) {
      modifyTableQuery(nextTableQuery);
    }
  }, [modifyTableQuery, tableQuery]);
  var handlePageChange = useCallback(function (pagination) {
    var nextPagination = Object.assign({}, tableQuery.pagination, pagination);
    var changed = !isEqual(tableQuery.pagination, nextPagination);
    if (changed) {
      modifyTableQuery(_objectSpread(_objectSpread({}, tableQuery), {}, {
        pagination: nextPagination
      }));
    }
  }, [modifyTableQuery, tableQuery]);

  /** 列表数据更新时, 同步修正 page/sorts 等信息 */
  var handleListUpdate = function handleListUpdate(page, totalCount) {
    var _page$index;
    var nextTotalCount = totalCount || 0;
    var nextPageNo = (_page$index = page === null || page === void 0 ? void 0 : page.index) !== null && _page$index !== void 0 ? _page$index : 1;
    if (page) {
      var size = page.size;
      handlePageChange({
        current: Number(nextPageNo),
        pageSize: Math.max(Number(size || 0), DEFAULT_PAGE_SIZE),
        total: nextTotalCount,
        showQuickJumper: true,
        showSizeChanger: true,
        responsive: true,
        showTotal: showTotal
      });
    }
  };
  var tData = useMemo(function () {
    return {
      searchForm: searchForm,
      isLoading: isFetching,
      data: data,
      pagination: tableQuery.pagination,
      filters: tableQuery.filters,
      sorter: tableQuery.sorter,
      requestQuery: requestQuery,
      tableProps: {
        bordered: true,
        size: 'middle',
        scroll: {
          x: 'max-content'
        },
        rowKey: 'key',
        loading: isFetching,
        pagination: tableQuery.pagination,
        dataSource: data,
        onChange: handleTableChange
      }
    };
  }, [searchForm, data, isFetching, requestQuery, tableQuery, handleTableChange]);
  var tAction = useMemo(function () {
    return {
      refetch: refetch,
      handleTableChange: handleTableChange,
      handleQueryChange: function handleQueryChange(nextQuery) {
        if (!nextQuery) {
          return;
        }
        var query = _objectSpread(_objectSpread(_objectSpread({}, createRequestQuery(pageSize, initialSort)), dataFilter(nextQuery)), {}, {
          _key: nanoid(5)
        });
        setRequestQuery(query);
        setTableQuery(createTableQuery(pageSize, initialSort));
        if (replaceUrlState) {
          var search = qs.stringify(query);
          window.history.replaceState({}, '', search ? "?".concat(search) : '');
        }
      }
    };
  }, [handleTableChange, initialSort, pageSize, refetch, replaceUrlState]);
  return [tData, tAction];
}
export default useTableQuery;